import { DisputeRecord, DisputeReasonLookupItem } from './response.types'

export type ReasonOption = DisputeReasonLookupItem

// Lookup отдаёт только включённые причины; выключенная текущая добавляется первой, иначе селект
// показал бы пустое значение и сохранить причину «без изменений» было бы нельзя.
export const buildReasonOptions = (
  lookup: DisputeReasonLookupItem[],
  current: DisputeRecord['reason']
): ReasonOption[] =>
  lookup.some((o) => o.value === current.id)
    ? lookup
    : [{ value: current.id, label: current.title }, ...lookup]
